// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_-wK","cls2":"dossier-cls2__ZK dossier-cls1_-wK"};